export const ONBOARDING_CHECKLIST_STORAGE_KEY = 'percurso:onboarding:checklist-dismissed';
export const SUITE_WELCOME_SEEN_KEY = 'percurso:suite:welcome-seen';

export function isOnboardingChecklistDismissed() {
  try {
    return localStorage.getItem(ONBOARDING_CHECKLIST_STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

export function dismissOnboardingChecklist() {
  try {
    localStorage.setItem(ONBOARDING_CHECKLIST_STORAGE_KEY, '1');
  } catch {
    // localStorage indisponível (SSR, modo privado restrito) — ignora.
  }
}

export function isSuiteWelcomeSeen() {
  try {
    return localStorage.getItem(SUITE_WELCOME_SEEN_KEY) === '1';
  } catch {
    return false;
  }
}

export function markSuiteWelcomeSeen() {
  try {
    localStorage.setItem(SUITE_WELCOME_SEEN_KEY, '1');
  } catch {
    // localStorage indisponível — ignora.
  }
}
